import { SwitchInput, useAlerts } from "@sis/react-library"
import { Track } from "../../../interfaces/dtos/track";
import { Box, Tooltip } from "@mui/material";
import { useState } from "react";
import { TrackListChangeStatusConfirmationItem } from "../../track/trackList/TrackListChangeStatusConfirmationItem";

interface ConfigurationsListItemSwitchInputProps {
    fieldName: keyof Track;
    track: Track;
    readOnly: boolean;
    onChange: (fieldName: keyof Track, value: boolean) => Promise<void>;
    tooltip?: string;
}

export const ConfigurationsListItemSwitchInput = ({
    fieldName, track, readOnly, onChange, tooltip
}: ConfigurationsListItemSwitchInputProps) => {

    const value = track[fieldName];

    const [changed, setChanged] = useState(false);
    const [saving, setSaving] = useState(false);
    const { confirm } = useAlerts();

    const formatFieldName = fieldName.replace("is", "")
        .replace("Display", " Display").replace("Distribute", " Distribute");

    const handleOnChange = () => {
        confirm(
            "Confirm changes",
            <>Are you sure you want to set '<b>{formatFieldName}</b>' to '<b>{value ? 'false' : 'true'}</b>' for the following?
                <ul>
                    <li>
                        <TrackListChangeStatusConfirmationItem track={track} />
                    </li>
                </ul>
            </>,
            () => applyChange(),
            "Yes", "No"
        );
    }

    const applyChange = async () => {
        try {
            setSaving(true);
            await onChange(fieldName, !value);
            setChanged(true);
        } finally {
            setSaving(false);
        }
    }

    return (
        <Tooltip id={`${track.key}-${fieldName}-input-tooltip`} title={tooltip} arrow placement="left">
            <Box sx={{ ".MuiFormControlLabel-labelPlacementEnd": { marginRight: 0 } }}>
                <SwitchInput
                    id={`${track.key}-${fieldName}-input`}
                    value={value}
                    disabled={readOnly}
                    loading={saving}
                    showFeedback={changed}
                    onChange={handleOnChange}
                />
            </Box>
        </Tooltip>
    )
}
